import Cookies from 'js-cookie'
import { useAuthSessionStore } from '@/store/authSessionStore'
import { applyAuthSessionTokens } from './applyAuthSessionTokens.js'

export function processAuthSession(res, options = {}) {
  const { onAuthSuccess, onSuccess, loginType = 'email' } = options
  if (!res?.success) return res?.message || 'Authentication failed'

  const user = res?.data?.user || res?.user
  const token = res?.data?.token || res?.data?.access_token || res?.token || ''
  const refreshToken = res?.data?.refresh_token || res?.refresh_token || ''

  if (!user || !token) return 'Authentication failed'

  applyAuthSessionTokens(user, token, refreshToken, loginType)
  ;(onSuccess ?? onAuthSuccess)?.()
  return null
}

export function clearAuthSession() {
  useAuthSessionStore.getState().clearSession()
  Cookies.remove('authToken')
}
